import { BusinessPatchDto } from "./../../../@types/dtos/business/BusinessPatchDto";
import { useRequest, useAuth } from "@onefront/react-sdk";
import { useCurrentTenant } from "@drift/oneplatfront";
import { generateHeaders } from "../../../utils/generate-headers";

interface IParamsFetch {
    params?: any;
    headers?: any;
    data?: BusinessPatchDto;
    url?: string;
}

interface IusePatchBusiness {
    (workspaceId?: string, businessId?: string): {
        data?: BusinessPatchDto;
        loading?: boolean;
        fetch: (fetchConfig?: IParamsFetch) => Promise<any>;
        error: boolean;
    };
}

export const usePatchBusiness: IusePatchBusiness = (workspaceId, businessId) => {
    const { tenant } = useCurrentTenant(true);
    return useRequest({
        method: "patch",
        headers: generateHeaders(useAuth(), tenant?.itemId, workspaceId),
        url: `rnd:core:workspace-write:api://v1/workspaces/${workspaceId}/business/${businessId}`,
        lazy: true
    });
};
